let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cU2oM")).then(() => parcelRequire('g02gC'));